<template>
  <div>

    <main role="main">

      <div class="container">

        <loading :active.sync="isLoading"
                 :can-cancel="false"
                 :is-full-page="false"></loading>

        <div class="row">

          <div class="col-md-12">

            <h2 class="mb-3">
              <i class="fa fa-file"></i> {{ $t('text.reports.reports') }}

              <GenerateReportButton
                  id="reportsBtn"
                  class="float-right"
                  :guiLocation="'OSTALO'"
              />

            </h2>

          </div>
        </div>

        <div class="row">

          <div class="col-md-12">

            <div class="table-responsive">
              <table class="table searchResults table-hover" v-if="myReports.length > 0">
                <thead>
                <tr>
                  <th>#</th>
                  <th>{{ $t('text.metadata.title') }}</th>
                  <th>{{ $t('text.globals.date') }}</th>
                  <th>{{ $t('text.reports.query') }}</th>
                  <th style="width: 200px;">{{ $t('text.globals.actions') }}</th>
                </tr>
                </thead>
                <tbody>

                <tr v-for="(item,index) in myReports" :key="index">
                  <td class="align-middle">{{ index + 1 }}</td>

                  <td class="align-middle">

                    <div class="badge badge-danger" v-if="item.error">{{ $t('text.reports.errorBold') }}</div>
                    <span>{{ item.name }}</span><br v-if="item.description"/>
                    <div v-if="item.description">
                      <em style="overflow: hidden; text-overflow: ellipsis; display: inline-block; max-width: 70ch; white-space: nowrap; position: relative;">{{ item.description }}</em>
                      <i class="fa fa-info-circle" style="position:absolute; margin-top: 3px; margin-left: 5px;"
                         v-if="item.description.length >= 67" v-b-tooltip.hover :title="item.description"></i>
                    </div>
                    <div v-if="!item.description">
                      <em class="text-muted">{{ $t('text.reports.noDescription') }}</em>
                    </div>
                  </td>

                  <td class="align-middle">{{ moment(item.date).local().format('DD.MM.YYYY HH:mm') }}
                  </td>
                  <td class="text-center align-middle">

                                            <span class="d-inline-block" :id="`popover-${index}`">
                                                <i class="fas fa-info-circle"></i>
                                            </span>

                    <b-popover :target="`popover-${index}`" triggers="hover focus">
                      <template slot="title">{{ $t('text.reports.query') }}</template>
                      {{ item.query }}
                    </b-popover>
                  </td>
                  <td class="align-middle">
                    <a class="btn btn-sm btn-info text-white" @click="download(item)"><i
                        class="fa fa-download"></i> {{ $t('text.globals.download') }}</a>
                    <a class="btn btn-sm btn-danger text-white" @click="deleteItem(item)"><i
                        class="fa fa-trash"></i> {{ $t('text.globals.delete') }}</a>
                  </td>
                </tr>
                </tbody>
              </table>

              <a
                  v-if="hasMoreResults"
                  @click="loadMoreItems"
                  class="btn btn-sm btn-link text-info ml-3"
              ><i class="fa fa-download"></i
              >{{
                  $t(
                      "text.documentSearch.documentSearchTectonical.loadMoreDocuments"
                  )
                }}</a
              >

            </div>
          </div>

        </div>


      </div>

    </main>

  </div>
</template>

<script type="text/javascript">
import Vue from 'vue';
import axios from 'axios';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import $ from 'jquery';
import AudiLogTable from "../components/AuditLogTable";
import GenerateReportButton from "../components/GenerateReportButton";

export default {
  name: 'AuditLog',
  components: {
    Loading,
    vSelect,
    AudiLogTable,
    GenerateReportButton
  },

  data() {
    return {
      isLoading: false,
      showPopover: false,
      randomKey: Math.random().toString(36).substring(2) + Date.now().toString(36),
      myReports: [],
      reportTypeOptions: [],
      hasMoreResults: true,
      page: 0,
      limit: 100,
    };
  },

  computed: {},

  mounted() {
    const _this = this;


    let p1 = _this.$store.dispatch("retrieveReportTypeOptions");

    Promise.all([p1]).then(() => {
      _this.reportTypeOptions = this.$store.getters.getReportTypeOptions;
      // _this.reportTypeOptions = _.filter(this.$store.getters.getReportTypeOptions, {'guiLocation': 'OSTALO'});
      _this.retrieveMyReports();
    });
  },

  methods: {
    loadMoreItems() {
      this.page = this.page + 1;
      this.retrieveMyReports();
    },

    retrieveMyReports() {
      const _this = this;

      _this.isLoading = true;

      axios.get(config.rootEhramba + 'reportHistory?offset=' + _this.page * _this.limit + '&limit=' + _this.limit)
          .then((res) => {
            console.log("res", res);

            _this.hasMoreResults = res.data.hasMore;

            let newReports = res.data.items;

            for(let i = 0; i < newReports.length; i++) {

              let reportType = _this.reportTypeOptions.find(obj => {
                return obj.reportType === newReports[i].type
              });

              if(reportType) {
                newReports[i]["name"] = reportType.name;
              }
              else {
                newReports[i]["name"] = this.$t('text.reports.unknownReportType');
              }

            }

            _this.myReports = _this.myReports.concat(newReports);
            _this.isLoading = false;

          })
          .catch((error) => {
            console.error(error);
          });

    },

    download(item) {
      const _this = this;

      this.isLoading = true;

      axios.get(config.alfrescoCoreApi + 'nodes/' + item.nodeId + '/content?attachment=true', {
        method: 'GET',
        responseType: 'blob' //Force to receive data in a Blob Format
      })

          .then((res) => {

            console.log("RESPONSE ", res);

            const url = window.URL.createObjectURL(_this.blobToFile(res.data, item.title));
            const link = document.createElement('a');

            link.href = url;
            link.setAttribute('download', item.title);
            link.setAttribute('type', item.type);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            this.isLoading = false;

          })
          .catch((error) => {
            console.error(error);

            this.isLoading = false;
          });


    },

    blobToFile(theBlob, fileName) {
      theBlob.lastModifiedDate = new Date();
      theBlob.name = fileName;
      return theBlob;
    },

    deleteItem(item) {
      const _this = this;


      this.$swal({
        title: this.$t("text.globals.warningTitle"),
        text: this.$t("text.reports.deleteReportSwal.prompt") + " " + item.title + "?",
        dangerMode: true,
        buttons: {
          cancel: {
            text: this.$t("text.globals.cancel"),
            value: null,
            visible: true,
            className: "",
            closeModal: true,
          },
          confirm: {
            text: this.$t("text.globals.delete"),
            value: true,
            visible: true,
            className: "",
            closeModal: true
          }
        },
      })
          .then((value) => {

            switch (value) {

              case true:

                _this.deleteAfterConfirmation(item.nodeId);

              case null:

                return;

                break;

              default:

            }
          });


    },

    deleteAfterConfirmation(nodeId) {
      const _this = this;

      _this.isLoading = true;

      axios.delete(config.alfrescoCoreApi + 'nodes/' + nodeId + '?permanent=true')
          .then((res) => {
            console.log("POROČILO IZBRISANO");
            _this.isLoading = false;
            _this.retrieveMyReports();
          })
          .catch((error) => {
            _this.isLoading = false;
            console.error(error);
          });
    },

  }
};
</script>



// WEBPACK FOOTER //
// src/pages/Reports.vue